import { Box, Typography, Stack, Link } from "@mui/material";
import PointsSkeleton from "../PointsSkeleton";

const FooterColumn = ({ title, links, handleScroll, theme }) => {
    return (
        <Box>
            {/* Title */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1.5 }}>
                <Box sx={{ width: 24, height: 2, bgcolor: theme.palette.primary.main }} />
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{ 
                        color: theme.palette.common.white,
                        fontFamily: theme.typography.h3.fontFamily
                    }}
                >
                    {title}
                </Typography>
            </Box>

            {/* Links */}
            <Stack spacing={2}>
                {links.length === 0 ? (
                    <PointsSkeleton count={4} />
                ) : (
                    links.map((link, i) => (
                        <Link
                            key={i}
                            onClick={() => handleScroll(link.id)}
                            underline="none"
                            sx={{
                                cursor: "pointer",
                                color: theme.palette.custom.footerText,
                                transition: "0.3s",
                                "&:hover": {
                                    color: theme.palette.custom.footerLinkHover,
                                },
                                typography: 'textSm'
                            }}
                        >
                            {link.label}
                        </Link>
                    ))
                )}
            </Stack>
        </Box>
    );
}

export default FooterColumn